import { Layers, Store, Scissors, Languages } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  {
    icon: Layers,
    title: "Wide Variety",
    text: "Everyday garments and essentials for the whole family.",
  },
  {
    icon: Store,
    title: "Convenient Shopping",
    text: "Multiple categories available under one roof, open daily 8 AM – 10 PM.",
  },
  {
    icon: Scissors,
    title: "Alteration Services",
    text: "Professional alteration support for men and women.",
  },
  {
    icon: Languages,
    title: "Your Language, Welcome",
    text: "Hindi, Kannada, English, Rajasthani & Haryanvi spoken in-store.",
  },
];

export const Trust = () => (
  <section className="bg-cream-muted text-charcoal py-16 sm:py-24 border-y border-cream-line">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-xl mx-auto">
        <Eyebrow light>Why families shop with us</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-balance">
          A neighbourhood store you can rely on.
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {PILLARS.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={i * 0.08}>
            <div data-testid={`trust-pillar-${i + 1}`} className="text-center">
              <span className="inline-flex w-14 h-14 rounded-full border border-gold/40 bg-gold/10 items-center justify-center text-gold-deep">
                <Icon size={24} strokeWidth={1.8} />
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold">{title}</h3>
              <p className="mt-2 text-sm text-charcoal/55 leading-relaxed max-w-[220px] mx-auto">
                {text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
